<template>
  <div class="relative bg-primary-50 h-screen w-screen dark:bg-gray-900">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useUIStore } from '~/stores/useUIStore'
import { useReactiveTheme } from '~/composables/useTheme'

const { $auth } = useNuxtApp()
const uiStore = useUIStore()

useReactiveTheme(
  () => ($auth as any).theme,
  () => ($auth as any).info?.location?.title,
)

const setWidth = (val: number) => uiStore.setWidth(val)

onMounted(() => {
  setWidth(window.innerWidth)

  window.addEventListener('resize', () => {
    setWidth(window.innerWidth)
  })
})
</script>
